<template>
  <div v-bind:class="{'odds-input-container--disabled':(!marketIsActive || !runnerIsActive) && editMode}"
       class="odds-input-container">
    <div class="odds-input-wrapper"
         v-bind:class="{'odds-input--disabled':(!marketIsActive || !runnerIsActive) && editMode}">
      <transition name="slide-left">
        <button v-if="editMode"
                v-bind:class="[
        type === 'back' ? 'odds-input-control-back':'odds-input-control-lay',

        ]"
                class="odds-input-control odds-input-dec" v-on:mousedown="handleDecrement($event)">-
        </button>
      </transition>

      <!-- <input :ref="`input-${betData.refId?betData.refId:betData.id}`"
             v-on:keyup="processOdds($event)"
             v-on:keydown="allowOnly2DecimalsForOdds"
             @paste="allowOnly2DecimalsForOdds"-->
      <input :ref="`input-${betData.refId?betData.refId:betData.id}`"
             v-on:blur="handleBlur"
             v-on:input="validateInput($event)"
             class="odds-input"
             autocomplete="off"

             :id="`oddsInput-${betData.refId?betData.refId:betData.id}`" :value="oddsValue"

             inputmode="decimal"
             pattern="[0-9]+([\.][0-9]{1,2})?"
             type="text"

             v-bind:class="{'edit-mode-disabled':!editMode}"
             v-focus>
      <transition name="slide-right">
        <button v-if="editMode"
                v-bind:class="[type === 'back' ? 'odds-input-control-back':'odds-input-control-lay']"
                class="odds-input-control odds-input-inc" v-on:mousedown="handleIncrement($event)">+
        </button>
      </transition>
    </div>
  </div>

</template>

<script>
// v-on:keydown="allowOnly2DecimalsForOdds"

export default {
  name: 'kryptOddsInput',
  props: [
    'inputSection',
    'runner',
    'betType',
    'betData',
    'betPosition',
    'odds',
    'event',
    'type',
    'alertId',
    'editMode'
  ],
  data: function () {
    return {
      oddsValue: '',
      oddsTempValue: '1.01',
      oddsLadder: {
        2: 1,
        3: 2,
        4: 5,
        6: 10,
        10: 20,
        20: 50,
        30: 100,
        50: 200,
        100: 500,
      }

    };
  },
  methods: {

    addBetMessage: function (betId, messageString) {
      this.$store.commit('addBetMessage', {
        id: betId,
        message: messageString
      });
    },
    handleIncrement: function () {
      if (this.oddsValue !== '100' && this.oddsValue !== '') {
        let odds = this.oddsValue;
        odds += '';
        let decimalPart = '';
        let integerPart = odds.split('.')[0].replace(/\D+/g, '');
        (odds.split('.')[1] ? decimalPart = odds.split('.')[1] : decimalPart = '');
        if (true) {
          //Add zeroes to decimal part
          decimalPart.length === 1 ? decimalPart += '0' : '';
          decimalPart.length === 0 ? decimalPart += '00' : '';
          //Convert decimal part to the corresponding increment
          if (Number(integerPart + decimalPart) < 200) {
            if ((Number(decimalPart) / this.oddsLadder[2] % 1 !== 0)) {
              decimalPart = (Math.trunc(Number(decimalPart) / this.oddsLadder[2]) * this.oddsLadder[2]) + this.oddsLadder[2];

            } else {
              decimalPart = Number(decimalPart) + this.oddsLadder[2];
            }
          } else if (200 <= Number(integerPart + decimalPart) && Number(integerPart + decimalPart) < 300) {
            if ((Number(decimalPart) / this.oddsLadder[3] % 1 !== 0)) {
              decimalPart = (Math.trunc(Number(decimalPart) / this.oddsLadder[3]) * this.oddsLadder[3]) + this.oddsLadder[3];

            } else {
              decimalPart = Number(decimalPart) + this.oddsLadder[3];
            }
          } else if (300 <= Number(integerPart + decimalPart) && Number(integerPart + decimalPart) < 400) {
            if ((Number(decimalPart) / this.oddsLadder[4] % 1 !== 0)) {
              decimalPart = (Math.trunc(Number(decimalPart) / this.oddsLadder[4]) * this.oddsLadder[4]) + this.oddsLadder[4];

            } else {
              decimalPart = Number(decimalPart) + this.oddsLadder[4];
            }
          } else if (400 <= Number(integerPart + decimalPart) && Number(integerPart + decimalPart) < 600) {
            if ((Number(decimalPart) / this.oddsLadder[6] % 1 !== 0)) {
              decimalPart = (Math.trunc(Number(decimalPart) / this.oddsLadder[6]) * this.oddsLadder[6]) + this.oddsLadder[6];

            } else {
              decimalPart = Number(decimalPart) + this.oddsLadder[6];
            }
          } else if (600 <= Number(integerPart + decimalPart) && Number(integerPart + decimalPart) < 1000) {
            if ((Number(decimalPart) / this.oddsLadder[10] % 1 !== 0)) {
              decimalPart = (Math.trunc(Number(decimalPart) / this.oddsLadder[10]) * this.oddsLadder[10]) + this.oddsLadder[10];

            } else {
              decimalPart = Number(decimalPart) + this.oddsLadder[10];
            }
          } else if (1000 <= Number(integerPart + decimalPart) && Number(integerPart + decimalPart) < 2000) {
            if ((Number(decimalPart) / this.oddsLadder[20] % 1 !== 0)) {
              decimalPart = (Math.trunc(Number(decimalPart) / this.oddsLadder[20]) * this.oddsLadder[20]) + this.oddsLadder[20];

            } else {
              decimalPart = Number(decimalPart) + this.oddsLadder[20];
            }
          } else if (2000 <= Number(integerPart + decimalPart) && Number(integerPart + decimalPart) < 3000) {
            if ((Number(integerPart + decimalPart) / this.oddsLadder[30] % 1 !== 0)) {
              integerPart = ((Math.trunc(Number(integerPart + decimalPart) / this.oddsLadder[30]) * this.oddsLadder[30]) + this.oddsLadder[30]) / 100;
              decimalPart = 0;

            } else {
              integerPart = (Number(integerPart + decimalPart) + this.oddsLadder[30]) / 100;
              decimalPart = 0;

            }

          } else if (3000 <= Number(integerPart + decimalPart) && Number(integerPart + decimalPart) < 5000) {
            if ((Number(integerPart + decimalPart) / this.oddsLadder[50] % 1 !== 0)) {
              integerPart = ((Math.trunc(Number(integerPart + decimalPart) / this.oddsLadder[50]) * this.oddsLadder[50]) + this.oddsLadder[50]) / 100;
              decimalPart = 0;

            } else {
              integerPart = (Number(integerPart + decimalPart) + this.oddsLadder[50]) / 100;
              decimalPart = 0;

            }

          } else if (5000 <= Number(integerPart + decimalPart) && Number(integerPart + decimalPart) < 10000) {
            if ((Number(integerPart + decimalPart) / this.oddsLadder[100] % 1 !== 0)) {
              integerPart = ((Math.trunc(Number(integerPart + decimalPart) / this.oddsLadder[100]) * this.oddsLadder[100]) + this.oddsLadder[100]) / 100;
              decimalPart = 0;

            } else {
              integerPart = (Number(integerPart + decimalPart) + this.oddsLadder[100]) / 100;
              decimalPart = 0;

            }

          } else {
            // decimalPart   Number(decimalPart) / this.oddsLadder[100]
          }
          odds = (Number(integerPart) * 100 + Number(decimalPart)) / 100;

        }

        if (odds.toString().length === 4) {
          if (odds.toString()
            .includes('.')) {
            odds = `${odds}`;
          } else {
            odds = `${odds}`.splice(2, 0, '.')
              .slice(0, -1);
          }
        }

        this.oddsValue = odds;
        console.log('ADD INCREMENT');
      } else if (this.oddsValue === '') {
        this.oddsValue = '1.01';
      }

    },
    handleDecrement: function () {
      if (this.oddsValue !== '1.01' && this.oddsValue !== '') {
        let odds = this.oddsValue;
        odds += '';
        let decimalPart = '';
        let integerPart = odds.split('.')[0].replace(/\D+/g, '');
        (odds.split('.')[1] ? decimalPart = odds.split('.')[1] : decimalPart = '');
        if (true) {
          //Add zeroes to decimal part
          decimalPart.length === 1 ? decimalPart += '0' : '';
          decimalPart.length === 0 ? decimalPart += '00' : '';

          //Convert decimal part to the corresponding increment
          if (Number(integerPart + decimalPart) <= 200) {
            if ((Number(decimalPart) / this.oddsLadder[2] % 1 !== 0)) {
              decimalPart = (Math.trunc(Number(decimalPart) / this.oddsLadder[2]) * this.oddsLadder[2]);

            } else {
              decimalPart = Number(decimalPart) - this.oddsLadder[2];
            }
          } else if (200 < Number(integerPart + decimalPart) && Number(integerPart + decimalPart) <= 300) {
            if ((Number(decimalPart) / this.oddsLadder[3] % 1 !== 0)) {
              decimalPart = (Math.trunc(Number(decimalPart) / this.oddsLadder[3]) * this.oddsLadder[3]);

            } else {
              decimalPart = Number(decimalPart) - this.oddsLadder[3];
            }
          } else if (300 < Number(integerPart + decimalPart) && Number(integerPart + decimalPart) <= 400) {
            if ((Number(decimalPart) / this.oddsLadder[4] % 1 !== 0)) {
              decimalPart = (Math.trunc(Number(decimalPart) / this.oddsLadder[4]) * this.oddsLadder[4]);

            } else {
              decimalPart = Number(decimalPart) - this.oddsLadder[4];
            }
          } else if (400 < Number(integerPart + decimalPart) && Number(integerPart + decimalPart) <= 600) {
            if ((Number(decimalPart) / this.oddsLadder[6] % 1 !== 0)) {
              decimalPart = (Math.trunc(Number(decimalPart) / this.oddsLadder[6]) * this.oddsLadder[6]);

            } else {
              decimalPart = Number(decimalPart) - this.oddsLadder[6];
            }
          } else if (600 < Number(integerPart + decimalPart) && Number(integerPart + decimalPart) <= 1000) {
            if ((Number(decimalPart) / this.oddsLadder[10] % 1 !== 0)) {
              decimalPart = (Math.trunc(Number(decimalPart) / this.oddsLadder[10]) * this.oddsLadder[10]);

            } else {
              decimalPart = Number(decimalPart) - this.oddsLadder[10];
            }
          } else if (1000 < Number(integerPart + decimalPart) && Number(integerPart + decimalPart) <= 2000) {
            if ((Number(decimalPart) / this.oddsLadder[20] % 1 !== 0)) {
              decimalPart = (Math.trunc(Number(decimalPart) / this.oddsLadder[20]) * this.oddsLadder[20]);

            } else {
              decimalPart = Number(decimalPart) - this.oddsLadder[20];
            }
          } else if (2000 < Number(integerPart + decimalPart) && Number(integerPart + decimalPart) <= 3000) {
            if ((Number(integerPart + decimalPart) / this.oddsLadder[30] % 1 !== 0)) {
              integerPart = ((Math.trunc(Number(integerPart + decimalPart) / this.oddsLadder[30]) * this.oddsLadder[30])) / 100;
              decimalPart = 0;

            } else {
              integerPart = (Number(integerPart + decimalPart) - this.oddsLadder[30]) / 100;
              decimalPart = 0;

            }

          } else if (3000 < Number(integerPart + decimalPart) && Number(integerPart + decimalPart) <= 5000) {
            if ((Number(integerPart + decimalPart) / this.oddsLadder[50] % 1 !== 0)) {
              integerPart = ((Math.trunc(Number(integerPart + decimalPart) / this.oddsLadder[50]) * this.oddsLadder[50])) / 100;
              decimalPart = 0;

            } else {
              integerPart = (Number(integerPart + decimalPart) - this.oddsLadder[50]) / 100;
              decimalPart = 0;

            }

          } else if (5000 < Number(integerPart + decimalPart) && Number(integerPart + decimalPart) <= 10000) {
            if ((Number(integerPart + decimalPart) / this.oddsLadder[100] % 1 !== 0)) {
              integerPart = ((Math.trunc(Number(integerPart + decimalPart) / this.oddsLadder[100]) * this.oddsLadder[100])) / 100;
              decimalPart = 0;

            } else {
              integerPart = (Number(integerPart + decimalPart) - this.oddsLadder[100]) / 100;
              decimalPart = 0;

            }

          } else {
            // decimalPart   Number(decimalPart) / this.oddsLadder[100]
          }
          odds = (Number(integerPart) * 100 + Number(decimalPart)) / 100;

        }

        if (odds.toString().length === 4) {
          if (odds.toString()
            .includes('.')) {
            odds = `${odds}`;
          } else {
            odds = `${odds}`.splice(2, 0, '.')
              .slice(0, -1);
          }
        }
        // else if (odds.toString().length === 3) {
        //   if (odds.toString()
        //     .includes('.')) {
        //     odds = `${odds}0`;
        //   } else {
        //     odds = `${odds}`;
        //   }
        // } else if (odds.toString().length === 2) {
        //   if (odds.toString()
        //     .includes('.')) {
        //     odds = `${odds}0`;
        //   } else {
        //
        //     odds = `${odds}.0`;
        //   }
        // } else if (odds.toString().length === 1) {
        //   odds = `${odds}.00`;
        // }
        this.oddsValue = odds;
        console.log('Remove INCREMENT');
      } else if (this.oddsValue === '') {
        this.oddsValue = '1.01';
      }

    },
    shouldAdjustValue: function (oddsValue) {
      if ((Number(oddsValue) > 100 || Number(oddsValue) < 1.01) && true) {
        return true;
      }
      if (this.oddsValue !== '100') {
        let odds = this.oddsValue;
        odds += '';
        let decimalPart = '';
        let integerPart = odds.split('.')[0].replace(/\D+/g, '');
        (odds.split('.')[1] ? decimalPart = odds.split('.')[1] : decimalPart = '');
        if (true) {
          //Add zeroes to decimal part
          decimalPart.length === 1 ? decimalPart += '0' : '';
          decimalPart.length === 0 ? decimalPart += '00' : '';
          //Convert decimal part to the corresponding increment
          if (Number(integerPart + decimalPart) < 200) {
            if ((Number(decimalPart) / this.oddsLadder[2] % 1 !== 0)) {
              return true;
            }
          } else if (200 <= Number(integerPart + decimalPart) && Number(integerPart + decimalPart) < 300) {
            if ((Number(decimalPart) / this.oddsLadder[3] % 1 !== 0)) {
              this.$store.commit(this.inputSection ==='openBets'?'setOpenBetMessage':'addBetMessage', {
                id: this.inputSection ==='openBets'?this.betData.id:this.betData.refId,
                messageType: 'temporaryOnClickRemove',
                messageId: 'betweenRange',
                type: 'error',
                message:
                  `${this.$t('bets.adjustmentMessages.betweenRange.message', {
                    lowerEnd: 2,
                    higherEnd: 3,
                    increment: 0.02
                  })}`
              });

              return true;

            }
          } else if (300 <= Number(integerPart + decimalPart) && Number(integerPart + decimalPart) < 400) {
            if ((Number(decimalPart) / this.oddsLadder[4] % 1 !== 0)) {
              this.$store.commit(this.inputSection ==='openBets'?'setOpenBetMessage':'addBetMessage', {
                id: this.inputSection ==='openBets'?this.betData.id:this.betData.refId,
                messageType: 'temporaryOnClickRemove',
                type: 'error',
                messageId: 'betweenRange',
                message: `${this.$t('bets.adjustmentMessages.betweenRange.message', {
                  lowerEnd: 3,
                  higherEnd: 4,
                  increment: 0.05
                })}`
              });

              return true;

            }
          } else if (400 <= Number(integerPart + decimalPart) && Number(integerPart + decimalPart) < 600) {
            if ((Number(decimalPart) / this.oddsLadder[6] % 1 !== 0)) {
              this.$store.commit(this.inputSection ==='openBets'?'setOpenBetMessage':'addBetMessage', {
                id: this.inputSection ==='openBets'?this.betData.id:this.betData.refId,
                messageType: 'temporaryOnClickRemove',
                messageId: 'betweenRange',
                type: 'error',
                message: `${this.$t('bets.adjustmentMessages.betweenRange.message', {
                  lowerEnd: 4,
                  higherEnd: 6,
                  increment: 0.1
                })}`
              });

              return true;

            }
          } else if (600 <= Number(integerPart + decimalPart) && Number(integerPart + decimalPart) < 1000) {
            if ((Number(decimalPart) / this.oddsLadder[10] % 1 !== 0)) {
              this.$store.commit(this.inputSection ==='openBets'?'setOpenBetMessage':'addBetMessage', {
                id: this.inputSection ==='openBets'?this.betData.id:this.betData.refId,
                messageType: 'temporaryOnClickRemove',
                messageId: 'betweenRange',
                type: 'error',
                message: `${this.$t('bets.adjustmentMessages.betweenRange.message', {
                  lowerEnd: 6,
                  higherEnd: 10,
                  increment: 0.2
                })}`
              });

              return true;

            }
          } else if (1000 <= Number(integerPart + decimalPart) && Number(integerPart + decimalPart) < 2000) {
            if ((Number(decimalPart) / this.oddsLadder[20] % 1 !== 0)) {
              this.$store.commit(this.inputSection ==='openBets'?'setOpenBetMessage':'addBetMessage', {
                id: this.inputSection ==='openBets'?this.betData.id:this.betData.refId,
                messageType: 'temporaryOnClickRemove',
                messageId: 'betweenRange',
                type: 'error',

                message: `${this.$t('bets.adjustmentMessages.betweenRange.message', {
                  lowerEnd: 10,
                  higherEnd: 20,
                  increment: 0.5
                })}`
              });

              return true;

            }
          } else if (2000 <= Number(integerPart + decimalPart) && Number(integerPart + decimalPart) < 3000) {
            if ((Number(integerPart + decimalPart) / this.oddsLadder[30] % 1 !== 0)) {
              this.$store.commit(this.inputSection ==='openBets'?'setOpenBetMessage':'addBetMessage', {
                id: this.inputSection ==='openBets'?this.betData.id:this.betData.refId,
                messageType: 'temporaryOnClickRemove',
                messageId: 'betweenRange',
                type: 'error',

                message: `${this.$t('bets.adjustmentMessages.betweenRange.message', {
                  lowerEnd: 20,
                  higherEnd: 30,
                  increment: 1
                })}`
              });

              return true;

            }

          } else if (3000 <= Number(integerPart + decimalPart) && Number(integerPart + decimalPart) < 5000) {
            if ((Number(integerPart + decimalPart) / this.oddsLadder[50] % 1 !== 0)) {
              this.$store.commit(this.inputSection ==='openBets'?'setOpenBetMessage':'addBetMessage', {
                id: this.inputSection ==='openBets'?this.betData.id:this.betData.refId,
                messageType: 'temporaryOnClickRemove',
                messageId: 'betweenRange',
                type: 'error',

                message: `${this.$t('bets.adjustmentMessages.betweenRange.message', {
                  lowerEnd: 30,
                  higherEnd: 40,
                  increment: 2
                })}`
              });

              return true;
            }

          } else if (5000 <= Number(integerPart + decimalPart) && Number(integerPart + decimalPart) < 10000) {
            if ((Number(integerPart + decimalPart) / this.oddsLadder[100] % 1 !== 0)) {
              this.$store.commit(this.inputSection ==='openBets'?'setOpenBetMessage':'addBetMessage', {
                id: this.inputSection ==='openBets'?this.betData.id:this.betData.refId,
                messageType: 'temporaryOnClickRemove',
                messageId: 'betweenRange',
                type: 'error',

                message: `${this.$t('bets.adjustmentMessages.betweenRange.message', {
                  lowerEnd: 50,
                  higherEnd: 100,
                  increment: 5
                })}`
              });

              return true;
            }

          } else {
            return false;
          }

        }

        this.oddsValue = odds;
        console.log('ADD INCREMENT');
      }

    },
    handleBlur: function (event) {
      if (this.shouldAdjustValue(this.oddsValue)) {
        if (Number(this.oddsValue) > 100) {
          this.oddsValue = '100';
          this.$store.commit(this.inputSection ==='openBets'?'setOpenBetMessage':'addBetMessage', {
            id: this.inputSection ==='openBets'?this.betData.id:this.betData.refId,
            messageType: 'temporaryOnClickRemove',
            messageId: 'aboveHighestEnd',
            type: 'error',

            message: this.$t('bets.adjustmentMessages.aboveHighestEnd')
          });
        } else if (Number(this.oddsValue) < 1.01) {
          this.oddsValue = '1.01';
          this.$store.commit(this.inputSection ==='openBets'?'setOpenBetMessage':'addBetMessage', {
            id: this.inputSection ==='openBets'?this.betData.id:this.betData.refId,
            messageType: 'temporaryOnClickRemove',
            messageId: 'belowLowestEnd',
            type: 'error',

            message: this.$t('bets.adjustmentMessages.belowLowestEnd')
          });
        } else if (this.betData.betType === 'lay') {
          this.handleDecrement();
        } else {
          this.handleIncrement();
        }
      }

      console.log('FOCUS OUT');

      //Adjust value on blur (focus out)

    },

    validateInput: function (event) {

      event.currentTarget.value = this.processInputNumber(event.target.value, event.target.selectionStart);
      this.oddsValue = event.currentTarget.value
    },
    processInputNumber: function (value, selectionStart) {
      let regExp = new RegExp('(\\d{0,2})?([.|,]{1}(\\d{0,2}))|(\\d{0,3})?([.|,]{1}(\\d{0,1}))?');
      let purifiedValue = value.match(regExp)[0].replace(',', '.');
      return (purifiedValue.startsWith('00') && (purifiedValue = purifiedValue.slice(2)),
      purifiedValue.startsWith('.') && selectionStart && (purifiedValue = '1' + purifiedValue),
        purifiedValue);

    },

    processOdds: function (event) {
      // alert(event.code)
      if ((event.key !== 'Delete' && event.key !== 'Backspace' && event.key !== '.' && event.keyCode !== 8 && event.keyCode !== 37 && event.keyCode !== 39 && this.oddsValue !== '.') ||
        ((event.key === '.') && !this.oddsValue.split('.')[2])) {
        let odds = event.currentTarget.value.replace(',', '.');
        odds += '';

        if (odds === '') {
          this.oddsValue = '1.01';
          this.oddsTempValue = 0;

        } else {
          if (odds.length > 4) {
            event.preventDefault();
          } else {
            this.oddsValue = odds;
          }
          // if(Number(odds)>100  ){
          //   this.oddsValue = '101'
          // }
          // if( Number(odds) <1.01 ){
          //   this.oddsValue = '1.01'
          // }
        }
        this.$forceUpdate();

      }

    },
    allowOnly2DecimalsForOdds: function (event) {

      if (event.keyCode !== 8 && event.keyCode !== 46 && event.keyCode !== 37 && event.keyCode !== 38 && event.keyCode !== 39) {
        if (((event.keyCode < 96 && event.keyCode > 57 && event.keyCode !== 110) || (event.keyCode > 105 && event.keyCode !== 110) || event.keyCode === 32) && (event.keyCode === 190 || event.keyCode === 110)) {
          if (!event.ctrlKey && event.key !== '.') {
            event.preventDefault();
            return false;
          }

        } else if ((event.key === '.') && this.oddsValue.includes('.')) {
          event.preventDefault();
          // this.$forceUpdate()
          return false;
        }
        if (event.type === 'input' && isNaN(event.currentTarget.value)) {
          this.clearEmptyValue(event);
        }
        if (event.currentTarget.value.length > 3 || (event.currentTarget.value.length === 4 && !event.currentTarget.value.includes('.'))) {
          event.preventDefault();
        }
        let paste = '';
        (event.clipboardData || window.clipboardData) ? paste = (event.clipboardData || window.clipboardData)?.getData('text') : '';
        if (paste !== '' && (isNaN(paste) || paste.length > 3 || (paste.length === 4 && !paste.includes('.')))) {
          event.preventDefault();
        }
      }

    },
    clearEmptyValue: function (event) {
      if (event.currentTarget.value === '' || isNaN(event.currentTarget.value)) {
        this.oddsValue = '1.00';
      }
    }
  },
  watch: {
    betData: function () {
      this.oddsValue = this.betData.odds;
      this.oddsTempValue = this.betData.odds;
      console.log(this.betData);
    },
    oddsValue: function (newValue, oldValue) {
      if (this.inputSection === 'betslip') {
        this.$store.commit('setOddsForBet', {
          position: this.betPosition,
          odds: newValue,
          betType: this.betData.betType
        });
      }
      if (this.inputSection === 'openBets' && this.$store.state.bets.active.betsBeingUpdated[this.betData.id]) {
        this.$store.commit('setBetBeingUpdatedOdds', {
          position: this.betData.id,
          odds: newValue,
          betType: this.betData.betType
        });
      }
    },
    marketIsActive: function (newValue) {
      if (!newValue) {
        document.getElementById(`oddsInput-${this.betData.refId ? this.betData.refId : this.betData.id}`)
          .blur();
      }
      ;

    },
    runnerIsActive: function (newValue) {
      if (!newValue) {
        document.getElementById(`oddsInput-${this.betData.refId ? this.betData.refId : this.betData.id}`)
          .blur();
      }
      ;
    }
  },
  computed: {
    market: function () {
      return this.$store.state.markets[this.betData.eventId]?.markets[this.betData.marketId];
    },
    betRunner: function () {
      return (this.market ? this.market.runners.find((runner) => {
        return runner.id === this.betData.runnerId;
      }) : '');
    },
    marketIsActive: function () {
      return this.market ? this.market.status !== 'INACTIVE' && this.market.status !== 'SUSPENDED' : false;
    },
    runnerIsActive: function () {
      return this.betRunner ? this.betRunner.active : false;
    },
    shouldRefocus:function () {
      return this.$store.state.bets.shouldRefocus;
    },
    newestBet: function () {
      return this.$store.state.bets.betslip.newestBet;
    },
  },
  mounted() {
    if (this.betData.odds !== '') {
      this.$nextTick(() => {
        this.oddsValue = this.betData.odds;
        this.oddsTempValue = this.betData.odds;
      });

    }

  },
  directives: {
    focus: {
      inserted: function (el,binding,vnode) {
        if(vnode.context.betData.odds ==='' && vnode.context.shouldRefocus && vnode.context.newestBet.refId === vnode.context.betData.refId){
          console.log("here")
          setTimeout(() =>  el.focus(),100)
          vnode.context.$store.commit('setRefocus',false)
        }
      }
    }
  }
};
</script>

<style scoped>

  .odds-input-container {
    display: flex;
    min-width: 80px;
    max-width: 80px;
    height: 100%;
  }

  .odds-input-wrapper {
    display: flex;
    justify-content: center;
    height: 28px;
    width: 100%;
    position: relative;
  }

  .odds-input {
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc(100% - 41px);
    text-align: center;
    padding: 5px 0;
    border: 1px solid transparent;
    border-top: solid 1px var(--grey-300);
    border-bottom: solid 1px var(--grey-300);
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    color: var(--grey-900);
    transition: all 0.5s ease-in-out;
    position: absolute;
    z-index: 1;
    background-color: white;
    caret-color: var(--primary);
    max-height: 28px;
  }

  .odds-input-control {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--grey-300);
    color: white;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    text-align: center;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;
    position: absolute;
    z-index: 0;
  }

  .odds-input-wrapper:not(.odds-input--disabled) .odds-input-control:hover {
    background-color: var(--grey-400);
  }

  .odds-input-dec {
    border-radius: 6px 0px 0px 6px;
    padding: 6px 8px;
    left: 0;
  }

  .odds-input-inc {
    border-radius: 0px 6px 6px 0px;
    padding: 6px 7px;
    right: 0;
  }

  .odds-input-wrapper button:focus {
    outline: none;
    border: none;
  }

  .odds-input:focus {
    outline: none;
    border-top: solid 1px var(--grey-300) !important;
    border-bottom: solid 1px var(--grey-300) !important;
  }

  .odds-input-wrapper:focus-within .odds-input-control-back {
    background-color: var(--superman);
  }

  .odds-input-wrapper:focus-within .odds-input-control-back:hover {
    background-color: var(--superman-state);
  }

  .odds-input-wrapper:focus-within .odds-input-control-lay {
    background-color: var(--lex-luthor);
  }

  .odds-input-wrapper:focus-within .odds-input-control-lay:hover {
    background-color: var(--lex-luthor-state);
  }

  .odds-input--disabled * {
    /*pointer-events: none;*/
  }

  .odds-input--disabled {
    opacity: 0.6;
  }

  .odds-input--disabled button,
  .odds-input--disabled input {
    cursor: not-allowed;
  }

  .odds-input-container--disabled {
    cursor: not-allowed;
    height: 100%;
  }

  .odds-input-container--disabled *{
    pointer-events: none;
  }

  .edit-mode-disabled {
    width: 100%;
    border: solid 1px var(--grey-100);
    border-radius: 6px;
    background-color: var(--grey-100);
  }

  .view-mode .odds-input-wrapper{
    cursor: text;
  }

  .view-mode input {
    pointer-events: none;
  }

  .slide-left-enter-active, .slide-left-leave-active {
    transition: all 0.3s ease-in-out;
  }

  .slide-left-enter, .slide-left-leave-to {
    transform: translateX(20px);
    opacity: 0;
  }

  .slide-right-enter-active, .slide-right-leave-active {
    transition: all 0.3s ease-in-out;
  }

  .slide-right-enter, .slide-right-leave-to {
    transform: translateX(-20px);
    opacity: 0;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type=number] {
    -moz-appearance: textfield;
  }

  input:invalid {
    box-shadow: none;
  }

</style>
